import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiArrowLeft, FiSave, FiCheck } = FiIcons;

const ModuleLayout = ({ 
  title, 
  description, 
  icon: Icon, 
  children, 
  onSave, 
  completed, 
  canComplete,
  isLoading = false 
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Link 
                to="/" 
                className="flex items-center space-x-2 text-gray-600 hover:text-blue-600 transition-colors"
              >
                <SafeIcon icon={FiArrowLeft} />
                <span className="text-sm font-medium">Back to Dashboard</span>
              </Link>
            </div>
            <div className="flex items-center space-x-4">
              {completed && (
                <div className="flex items-center space-x-2 text-green-600">
                  <SafeIcon icon={FiCheck} className="text-sm" />
                  <span className="text-sm font-medium">Complete</span>
                </div>
              )}
              <button
                onClick={() => onSave(false)}
                disabled={isLoading}
                className="flex items-center space-x-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors disabled:opacity-50"
              >
                <SafeIcon icon={FiSave} className="text-sm" />
                <span className="text-sm font-medium">Save Progress</span>
              </button>
              {canComplete && (
                <button
                  onClick={() => onSave(true)}
                  disabled={isLoading}
                  className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-orange-600 hover:shadow-lg text-white rounded-lg transition-all disabled:opacity-50"
                >
                  <SafeIcon icon={FiCheck} className="text-sm" />
                  <span className="text-sm font-medium">Mark Complete</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Module Header */}
      <div className="bg-white">
        <div className="max-w-4xl mx-auto px-4 py-8">
          <div className="flex items-start space-x-4">
            <div className="w-16 h-16 rounded-xl bg-gradient-to-r from-blue-500 to-orange-500 flex items-center justify-center flex-shrink-0">
              <SafeIcon icon={Icon} className="text-2xl text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900 mb-2">{title}</h1>
              <p className="text-gray-600 leading-relaxed max-w-3xl">{description}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Module Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
};

export default ModuleLayout;